module.exports = __webpack_public_path__ + "img/_drag.48a37a96.svg";